import type {SubscriptionState} from './subscriptionTypes';

/**
 * Called on `start_ack` — AppSync accepted THIS user's subscription, which
 * proves the token+authorization are working. Clearing the counter arms the
 * self-heal loop to try `MAX_REAUTH_ATTEMPTS` more times on future rejections.
 */
export const clearReauthAttempts = (state: SubscriptionState) => {
  state.reauthAttempts = 0;
};
